import "./OperatorListSkeleton.scss";

interface Props {
    elementsNumber?: number;
}

export const OperatorListSkeleton = ({ elementsNumber = 3 }: Props) => {
    return (
        <div className="operator-list-skeleton">

            <div className="operator-skeleton-search-header">
                <div className="operator-skeleton-title pulse"></div>
                <div className="operator-skeleton-subtitle pulse"></div>
            </div>
            <div className="operator-skeleton-pagination-top">
                <div className="operator-skeleton-page-size pulse"></div>
                <div className="operator-skeleton-results-text pulse"></div>
                <div className="operator-skeleton-reset pulse"></div>
                <div className="operator-skeleton-sort pulse"></div>
            </div>

            <div className="operator-skeleton-actions-row">
                <div className="operator-skeleton-switch pulse"></div>
                <div className="operator-skeleton-exports">
                    <div className="operator-skeleton-export pulse"></div>
                    <div className="operator-skeleton-export pulse"></div>
                </div>
            </div>

            <div className="operator-skeleton-list">
                {Array(elementsNumber).fill(0).map((_, index) => (
                    <div key={index} className="operator-skeleton-card">
                        <div className="operator-skeleton-card-header">
                            <div className="operator-skeleton-name pulse"></div>
                            <div className="operator-skeleton-id pulse"></div>
                        </div>

                        <div className="operator-skeleton-card-body">
                            <div className="operator-skeleton-col">
                                <div className="operator-skeleton-label pulse"></div>
                                <div className="operator-skeleton-value pulse"></div>
                            </div>
                            <div className="operator-skeleton-col">
                                <div className="operator-skeleton-label pulse"></div>
                                <div className="operator-skeleton-value pulse"></div>
                            </div>
                            <div className="operator-skeleton-col">
                                <div className="operator-skeleton-label pulse"></div>
                                <div className="operator-skeleton-value pulse"></div>
                            </div>
                            <div className="operator-skeleton-col">
                                <div className="operator-skeleton-label pulse"></div>
                                <div className="operator-skeleton-value pulse"></div>
                            </div>
                        </div>

                        <div className="operator-skeleton-card-footer">
                            <div className="operator-skeleton-accordion pulse"></div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="operator-skeleton-pagination-bottom">
                <div className="operator-skeleton-pagination-pages pulse"></div>
            </div>
        </div>
    );
};
